import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiAddNewContact = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'addNewContactDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceURL, payload);
};
